var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRotateLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4981 23.2506C7.29813 23.2506 3.07812 19.0206 3.07812 13.8306C3.07812 11.9606 3.62813 10.1506 4.66813 8.59063C4.89813 8.25063 5.36813 8.15062 5.70813 8.38062C6.04813 8.61062 6.14813 9.08063 5.91813 9.42063C5.04813 10.7206 4.58812 12.2506 4.58812 13.8206C4.58812 18.1906 8.13813 21.7406 12.5081 21.7406C16.8781 21.7406 20.4281 18.1906 20.4281 13.8206C20.4281 9.45063 16.8681 5.90062 12.4981 5.90062C11.5781 5.90062 10.6781 6.03063 9.82812 6.29063C9.42812 6.41062 9.00813 6.19063 8.88813 5.79063C8.76813 5.39063 8.98813 4.97063 9.38813 4.85063C10.3881 4.55063 11.4281 4.39062 12.4981 4.39062C17.6981 4.39062 21.9181 8.62063 21.9181 13.8106C21.9181 19.0006 17.6981 23.2506 12.4981 23.2506Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.37036 6.56817C8.20036 6.56817 8.02036 6.50817 7.88036 6.38817C7.56036 6.10817 7.53036 5.63817 7.80036 5.32817L10.6904 2.00817C10.9604 1.69817 11.4404 1.65817 11.7504 1.93817C12.0604 2.20817 12.0904 2.68817 11.8204 2.99817L8.93036 6.30817C8.78036 6.47817 8.57036 6.56817 8.37036 6.56817Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7396 9.03208C11.5896 9.03208 11.4296 8.98208 11.2996 8.89208L7.91959 6.42208C7.58959 6.18208 7.51959 5.71208 7.75959 5.38208C7.99959 5.04208 8.46959 4.97208 8.80959 5.21208L12.1796 7.67208C12.5096 7.91208 12.5896 8.38208 12.3396 8.72208C12.1996 8.93208 11.9696 9.03208 11.7396 9.03208Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotateLeft);
export default __webpack_public_path__ + "static/media/rotate-left.cc38f5ec5d1c8d5da8c75538f49d33a0.svg";
export { ForwardRef as ReactComponent };